import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HomeRichmediaAdsComponent } from './home-richmedia-ads/home-richmedia-ads.component';
import { FormRichmediaAdsComponent } from './form-richmedia-ads/form-richmedia-ads.component';




@NgModule({
  declarations: [
    HomeRichmediaAdsComponent,
    FormRichmediaAdsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  providers: [DatePipe]
})
export class RichmediaAdsModule { }
